/* eslint no-useless-escape: "off" */

export default function() {
  return (input = '', max) => {
    if (input.length <= max) {
      return input
    } else {
      //  search for the index where the "path" part of the url begins
      const indexOfPath = input.search(/[^\/]\/[^\/]/) + 2
      const charsFromEndToDisplay = max - indexOfPath - 3

      return (
        input.slice(0, indexOfPath) +
        '...' +
        input.slice(-charsFromEndToDisplay)
      )
    }
  }
}
